import { Injectable } from '@angular/core';

import { StorageService } from './storage/storage.service';
import { ChatService } from './chat.service';
import { NotificationService } from './notification.service';
import { environment } from '../../../../environments/environment';
import * as _ from 'lodash';

type LiveConnection = {
  socketConn: WebSocket;
  retryConnectionAttempt: number;
  countdownTimer: boolean | ReturnType<typeof setTimeout>;
  attemptTimer: boolean | ReturnType<typeof setTimeout>;
  attemptScheduled: boolean;
  init: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  liveConnection: LiveConnection = {
    socketConn: null,
    retryConnectionAttempt: 0,
    countdownTimer: false,
    attemptTimer: false,
    attemptScheduled: false,
    init: () => {
      var appInfo = this;
      appInfo.liveConnection.retryConnectionAttempt++;
      appInfo.liveConnection.attemptScheduled=false;
      appInfo.getSocketData({
          'getChatRoomUpdates':{
            "ClientTZDIFF": this.uaInfo.ClientTZDIFF
          }
      },() => {
        appInfo.reConnectTimer=false;
      });
    }
  };
  currentUser: any;
  uaInfo: any;
  appCache: any = {
    callbackQueue: {},
    persistantCallbackQueue: {},
  };
  reConnectTimer: any;
  cache: any;
  chatRooms: any;
  constructor(
    private storageService: StorageService,
    private chatService: ChatService,
    private notificationService: NotificationService
  ) {
  }
  
  setCurrentUser() {
    this.currentUser = this.storageService.getItem('SignIn');
  }
  
  setUAInfo() {
    this.uaInfo = this.storageService.getItem('uaInfo');
  }

  getSocketData(reqData: any = null, callback: any = null, isPersistant: boolean = false) {
    this.setCurrentUser();
    this.setUAInfo();
   // console.log("[SOC] initialize check initialize", this.liveConnection.socketConn, reqData ? Object.keys(reqData)[0] : 'Init');
    if (this.currentUser && (!this.liveConnection.socketConn)) {
      const connectionString: string = `${(location.protocol == 'https:' ? 'wss' : 'ws')}://${environment.SUBDOMAIN}.${environment.MASTER_DOMAIN}:${environment.CHAT_PORT}/echo/?${this.currentUser.LoginSessionKey}`;
      console.log("connestring", connectionString)
      this.liveConnection.socketConn = new WebSocket(connectionString);
     // console.log('[SOC] liveconnection', this.liveConnection);
      this.liveConnection.socketConn.onopen = (e) => {
        if (this.appCache.callbackQueue['socketOpen']) {
          for (var i in this.appCache.callbackQueue['socketOpen']) {
            this.liveConnection.socketConn.send(JSON.stringify(this.appCache.callbackQueue['socketOpen'][i]));
          }
          this.appCache.callbackQueue['socketOpen'] = [];
        }
      }
      this.liveConnection.socketConn.onmessage = this.processSocketResponse.bind(this);
      this.liveConnection.socketConn.onerror = this.socketConnectionFix.bind(this);
      this.liveConnection.socketConn.onclose = this.socketConnectionFix.bind(this);
    }
    if (reqData) {
      var callbackKey = Object.keys(reqData)[0];
      //console.log('[SOC] req data', reqData, callbackKey, this.liveConnection.socketConn);
      if (_.isFunction(callback)) {
        var q = !isPersistant ? 'callbackQueue' : 'persistantCallbackQueue';
        if (this.appCache[q][callbackKey]) {
          this.appCache[q][callbackKey].push(callback);
        }
        else
          this.appCache[q][callbackKey] = [callback];
      }
      if (this.liveConnection.socketConn && this.liveConnection.socketConn.readyState == 1) {
       // console.log("[SOC] Sending socket con", callbackKey);
        this.liveConnection.socketConn.send(JSON.stringify(reqData));
      } else {
        var callbackKey = 'socketOpen';
        if (_.isFunction(callback)) {
          if (this.appCache.callbackQueue[callbackKey]) {
            this.appCache.callbackQueue[callbackKey].push(reqData);
          }
          else{
            this.appCache.callbackQueue[callbackKey] = [reqData];
          }
        }
      }
    }
  }

  disconnectSocket() {
    //console.log("[SOC] disconnectSocket",this.liveConnection.socketConn);
    if (this.liveConnection.socketConn) {
      this.liveConnection.socketConn.close();
      delete this.liveConnection.socketConn;
      this.reConnectTimer = false;
    }
  }

  socketConnectionFix(e: any = null) {
    const appInfo = this;
   // console.log("[SOC] socketConnectionFix", e, appInfo.liveConnection.attemptScheduled);
    if (this.currentUser && !appInfo.liveConnection.attemptScheduled) {
      appInfo.liveConnection.attemptScheduled = true;
      appInfo.liveConnection.socketConn = null;
      const retryTime = 15000 * appInfo.liveConnection.retryConnectionAttempt;
      let ticker = retryTime / 1000;
      const countdown = () => {
        ticker--;
        if (ticker > 0) {
          if (ticker > 60) {
            this.reConnectTimer = (ticker / 60).toFixed(2) + 'm';
          } else {
            this.reConnectTimer = ticker + 's';
          }
          appInfo.liveConnection.countdownTimer = setTimeout(countdown, 1000);
        } else {
          this.reConnectTimer = false;
        }
      }
      countdown();
      // if(appInfo.retryConnectionAttempt<6){
					appInfo.liveConnection.attemptTimer=setTimeout(appInfo.liveConnection.init, retryTime);
					// $rootScope.showFlashMessage('info','Retrying connection to chat server.');
				// } else if(appInfo.retryConnectionAttempt)
				// 	$rootScope.showFlashMessage('error','Failed to connect chat server, Please retry later. If error persist please contact technical support.');
    }
  }

  processSocketResponse(response: any = null) {
    console.log("[SOC] response",response);
    this.liveConnection.retryConnectionAttempt = 0;
    this.reConnectTimer = false;
    const responseData = JSON.parse(response.data);
    
    let callbackKey = Object.keys(responseData)[0];
    if (responseData.getChatRoomUpdates && responseData.getChatRoomUpdates.message) {
      if(responseData.getChatRoomUpdates.updateType === 'newChatMessage') {
        callbackKey = 'sendChatMessage';
      }
      this.chatService.setChatData([responseData.getChatRoomUpdates.message]);
    }
    if(callbackKey == 'getNotifications'){
      this.notificationService.setNotificationData(responseData[callbackKey]);
    }
    if(callbackKey == 'markNotifications'){
      this.notificationService.setNotificationData(null);
    }
    this.processCallbackQueue(callbackKey, responseData);
    this.processPersistantCallbackQueue(callbackKey, responseData);
  }

  processCallbackQueue(apiKey, response) {
    //console.log('[SOC] processCallbackQueue', apiKey, this.appCache.callbackQueue);
    if (this.appCache.callbackQueue[apiKey]) {
      var callback = null;
      while (callback = this.appCache.callbackQueue[apiKey].shift()) {
        callback(response);
      }
    }
  };

  processPersistantCallbackQueue(apiKey, response) {
    //console.log('[SOC] processPersistantCallbackQueue', apiKey, this.appCache.persistantCallbackQueue);
    if (this.appCache.persistantCallbackQueue[apiKey]) {
      var callback = null;
      for (var i in this.appCache.persistantCallbackQueue[apiKey]) {
        this.appCache.persistantCallbackQueue[apiKey][i](response);
      }
    }
  };

  setNotificationData(data:any){
    this.notificationService.setNotificationData(data);
  }

  getNotificationData(){
    return this.notificationService.notificationObserval();
  }
}
